module.exports = __webpack_public_path__ + "img/SEARCH.7f8a9425.svg";